<template>
  <div class="mark" :class="type">
    <svg width="100%" height="100%" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient :id="'grad-' + type" x1="0%" y1="130%" x2="0%" y2="0%">
          <stop class="svg-grad" :class="type + '-init-grad'" offset="0%" />
          <stop class="svg-grad" :class="type + '-end-grad'" offset="100%" />
        </linearGradient>
      </defs>
      <polygon :style="{fill: 'url(#grad-' + type +')'}" class="mark-item" :points="points"/>
    </svg>
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    points: {
      type: String,
      default: '15, 3 3, 15 3, 35 35, 3'
    }
  }
}
</script>

<style lang="scss" scoped>
.mark {
  position: relative;
  z-index: 9;
  overflow: hidden;
  font-family: inherit;
  @include px2res(font-size, 24);
}
.svg-grad {
  stop-opacity: 1;
}
.init-grad {
  stop-color: rgb(0, 255, 252);
}
.end-grad {
  stop-color: rgb(0, 150, 255);
}
.normal-init-grad {
  stop-color: rgb(0, 255, 252);
}
.normal-end-grad {
  stop-color: rgb(0, 150, 255);
}
.light-init-grad {
  stop-color: rgb(255, 161, 26);
}
.light-end-grad {
  stop-color: rgb(255, 84, 0);
}
@keyframes colors {
  0% { fill: #fced64; }
  100% { fill: #FFC143; }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Mark.vue